export const GET_ALL_APPEAL_RECEIVER_GROUP = "GET_ALL_APPEAL_RECEIVER_GROUP"
export const CREATE_APPEAL_RECEIVER_GROUP = "CREATE_APPEAL_RECEIVER_GROUP"
export const UPDATE_APPEAL_RECEIVER_GROUP = "UPDATE_APPEAL_RECEIVER_GROUP"
export const DELETE_APPEAL_RECEIVER_GROUP = "DELETE_APPEAL_RECEIVER_GROUP"
export const SELECT_APPEAL_RECEIVER_GROUP = "SELECT_APPEAL_RECEIVER_GROUP"
